<template>
  <footer v-if="sid === 'amseu'" class="cabinet-footer" aria-label="Fußbereich">
    <b-container class="cabinet-footer__inner">
      <amseu-footer-bottom />
    </b-container>
  </footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import AmseuFooterBottom from '@/components/Themes/AmseuFooterBottom.vue';

@Component({
  components: { AmseuFooterBottom },
})
export default class CabinetFooter extends Vue {
  get sid() {
    return AppModule.sid;
  }
}
</script>

<style lang="scss" scoped>
$footer-bg: #00478f;

.cabinet-footer {
  position: relative;
  z-index: 20;
  background: $footer-bg;

  &__inner {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>
